/*
Author: Gilang Romadhanu Tartila
*/
'use strict';

let MS_SOCO_PUBLIC_API_URL;
let MS_SOCO_ADMIN_API_URL;
let MS_BJ_PUBLIC_API_URL;
let MS_BJ_ADMIN_API_URL;
let MS_SOCIOLLA_API_URL;
let MS_SOCKET_API_URL;
let MS_SOCIOLLA_PUBLIC_URL;
let MS_CATALOG_API_URL;
let MS_CART_API_URL;
let MS_PAYMENT_API_URL;
let MS_SHIPPING_API_URL;
let MS_ORDER_API_URL;
let MS_SSO_BROKER_API_URL;
let MS_SOCIOLLA_PUBLIC_API_URL;
let SOCO_WEB_URL;
let SOCO_ADMIN_URL;
let BJ_WEB_URL;
let BJ_ADMIN_URL;
let REVIEW_WEB_URL;
let STORE_WEB_URL;
let SOCIOLLA_WEB_URL;
let SOCIOLLA_WEB_VN_URL;
let B2B_WEB_URL;
let B2B_WEB_VN_URL;
let LULLA_WEB_URL;
let LMS_WEB_URL;
let MS_POS_API_URL;
// eslint-disable-next-line no-unused-vars
let ENVIRONMENT;
let MS_ANALYTICS_API_URL;
let MS_CHATBOT_API_URL;
let MS_ACCOUNTS_API_URL;
let MS_B2B_ACCOUNTS_API_URL;
let MS_B2B_API_URL;
let MS_B2B_CATALOG_API_URL;
let MS_B2B_ORDERS_API_URL;

const ENV_PRODUCTION = 'production';
// eslint-disable-next-line no-unused-vars
const ENV_LOCAL = 'local';

// change this key
const ENV = ENV_PRODUCTION;

if (ENV === 'local') {
  MS_SOCO_PUBLIC_API_URL = `http://localhost:3001`;
  MS_SOCO_ADMIN_API_URL = `http://localhost:3041`;
  MS_BJ_PUBLIC_API_URL = `http://localhost:3051`;
  MS_BJ_ADMIN_API_URL = `http://localhost:3061`;
  MS_SOCKET_API_URL = `http://localhost:5000`;
  MS_SOCIOLLA_API_URL = `http://localhost:3001`;
  MS_CATALOG_API_URL = `http://localhost:4000`;
  MS_CART_API_URL = `http://localhost:4001`;
  MS_PAYMENT_API_URL = `http://localhost:4004`;
  MS_SHIPPING_API_URL = `http://localhost:4002`;
  MS_ORDER_API_URL = `http://localhost:4003`;
  MS_SSO_BROKER_API_URL = `http://localhost:4005`;
  MS_POS_API_URL = `http://localhost:3081`;
  MS_SOCIOLLA_PUBLIC_API_URL = '';
  MS_ANALYTICS_API_URL = `http://localhost:3002`;
  MS_CHATBOT_API_URL = `http://localhost:3003`;
  MS_ACCOUNTS_API_URL = `http://localhost:3021`;
  MS_B2B_ACCOUNTS_API_URL = `http://localhost:3021`;
  MS_B2B_API_URL = `http://localhost:3021`;
  MS_B2B_ORDERS_API_URL = `http://localhost:3021`;
  MS_B2B_CATALOG_API_URL = `http://localhost:4000`;
  SOCO_WEB_URL = `http://localhost:8080`;
  SOCO_ADMIN_URL = `http://localhost:8081`;
  BJ_WEB_URL = `http://localhost:8082`;
  BJ_ADMIN_URL = `http://localhost:8084`;
  REVIEW_WEB_URL = `http://localhost:8085`;
  STORE_WEB_URL = `http://localhost:8086`;
  SOCIOLLA_WEB_URL = `http://localhost:8087`;
  LULLA_WEB_URL = `http://localhost:8088`;
  LMS_WEB_URL = `https://guru.sociolla.info/login`;
  SOCIOLLA_WEB_VN_URL = `http://localhost:8089`;
  B2B_WEB_URL = `http://localhost:19006`;
  B2B_WEB_VN_URL = `http://localhost:19006`;
} else {
  MS_SOCO_PUBLIC_API_URL = `https://soco-api.sociolla.com`;
  MS_SOCO_ADMIN_API_URL = `https://soco-admin-api.sociolla.com`;
  MS_BJ_PUBLIC_API_URL = `https://bj-public-api.sociolla.com`;
  MS_BJ_ADMIN_API_URL = `https://bj-admin-api.sociolla.com`;
  MS_SOCKET_API_URL = `https://socket.sociolla.com`;
  MS_SOCIOLLA_API_URL = `https://api.sociolla.com`;
  MS_SOCIOLLA_PUBLIC_URL = `https://api.sociolla.com`;
  MS_CATALOG_API_URL = `https://catalog-api.sociolla.com`;
  MS_CART_API_URL = `https://carts-api.sociolla.com`;
  MS_PAYMENT_API_URL = `https://payments-api.sociolla.com`;
  MS_SHIPPING_API_URL = `https://shipping-api.sociolla.com`;
  MS_ORDER_API_URL = `https://orders-api.sociolla.com`;
  MS_SSO_BROKER_API_URL = `https://sso-broker.soco.id`;
  MS_POS_API_URL = `https://pos-api.sociolla.com`;
  MS_SOCIOLLA_PUBLIC_API_URL = `https://api.sociolla.com`;
  MS_ANALYTICS_API_URL = `https://analytics-api.soco.id`;
  MS_CHATBOT_API_URL = `https://chatbot-api.sociolla.com`;
  MS_ACCOUNTS_API_URL = `https://accounts-api.sociolla.com`;
  MS_B2B_ACCOUNTS_API_URL = `https://b2b-accounts.sociolla.info`;
  MS_B2B_API_URL = `https://b2b-api.sociolla.info`;
  MS_B2B_ORDERS_API_URL = `https://b2b-orders.sociolla.info`;
  MS_B2B_CATALOG_API_URL = `https://b2b-catalog.sociolla.info`;
  SOCO_WEB_URL = `https://soco.id`;
  SOCO_ADMIN_URL = `https://socoguru.sociolla.info`;
  BJ_WEB_URL = `https://journal.soco.id`;
  BJ_ADMIN_URL = `https://${ENV}-bj-admin.sociolabs.io`;
  REVIEW_WEB_URL = `https://review.soco.id`;
  STORE_WEB_URL = `https://store-kota.sociolla.com`;
  SOCIOLLA_WEB_URL = `https://sociolla.com`;
  LULLA_WEB_URL = `https://lilla.sociolla.com`;
  LMS_WEB_URL = `https://guru.sociolla.info/login`;
  SOCIOLLA_WEB_VN_URL = `https://vn.sociolla.com`;
  B2B_WEB_URL = `https://nina.sociolla.info`;
  B2B_WEB_VN_URL = `https://vn-nina.sociolla.info`;
}

module.exports.default = {
  NODE_ENV: 'production',
  ENVIRONMENT: 'production',

  MS_SOCO_PUBLIC_API_URL,
  MS_SOCO_ADMIN_API_URL,
  MS_BJ_PUBLIC_API_URL,
  MS_BJ_ADMIN_API_URL,
  MS_SOCIOLLA_API_URL,
  MS_SOCKET_API_URL,
  MS_CATALOG_API_URL,
  MS_CART_API_URL,
  MS_SOCIOLLA_PUBLIC_URL,
  MS_PAYMENT_API_URL,
  MS_ORDER_API_URL,
  MS_SHIPPING_API_URL,
  MS_SSO_BROKER_API_URL,
  MS_POS_API_URL,
  MS_SOCIOLLA_PUBLIC_API_URL,
  MS_ANALYTICS_API_URL,
  MS_CHATBOT_API_URL,
  MS_ACCOUNTS_API_URL,

  MS_B2B_ACCOUNTS_API_URL,
  MS_B2B_API_URL,
  MS_B2B_CATALOG_API_URL,
  MS_B2B_ORDERS_API_URL,

  SOCO_WEB_URL,
  SOCO_ADMIN_URL,
  BJ_WEB_URL,
  BJ_ADMIN_URL,
  REVIEW_WEB_URL,
  STORE_WEB_URL,
  SOCIOLLA_WEB_URL,
  LULLA_WEB_URL,
  LMS_WEB_URL,
  SOCIOLLA_WEB_VN_URL,
  B2B_WEB_URL,
  B2B_WEB_VN_URL,

  MS_SOCO_PUBLIC_API_LIST: [MS_SOCO_PUBLIC_API_URL],
  MS_BJ_PUBLIC_API_LIST: [MS_BJ_PUBLIC_API_URL],
  MS_CATALOG_API_LIST: [MS_CATALOG_API_URL],

  MS_CART_API_LIST: [MS_CART_API_URL],

  store_id: 5,
  store_lists: [
    { id: 5, value: 'KOKAS' },
    { id: 7, value: 'LMP' },
  ],
  midtrans: {
    env: 'sandbox',
    client_key: 'SB-Mid-client-IIhzdkGGmCm76LYK',
    url: 'https://api.sandbox.midtrans.com',
  },
  doku: {
    env: 'staging',
    DOKU_MALL_ID: '8164',
    DOKU_SHARED_KEY: 'bywjpT7IjmrS',
  },
  xendit: {
    publishable_key:
      'xnd_public_development_WLIvWXRgKl8MGdCgRjUDPfPFoniM46GNcvky3eBW4ByJGzEECe05C2SBoY5xs5V',
  },
  gpn: {
    url: 'https://bpgdev.bersama.id/ArtajasaPG/payment/salesRedirect',
  },
  consoleLogMode: false,
  OW_API_KEY: '59fed3396a52de044c2066984baafca6',
  MAP: 'google',
  // B2B-6051: in-app map is a WebView (Maps JS) which cannot use app-restricted
  // (bundle/SHA) keys, so all platforms use the None-restricted "API key for API".
  GOOGLE_MAP_KEY: 'AIzaSyBRMr6NOE8bXWqEnRcG6GBhud58xXRrnDY',
  GOOGLE_MAP_KEY_IOS: 'AIzaSyBRMr6NOE8bXWqEnRcG6GBhud58xXRrnDY',
  GOOGLE_MAP_KEY_ANDROID: 'AIzaSyBRMr6NOE8bXWqEnRcG6GBhud58xXRrnDY',
  RECAPTCHA_SITE_KEY: '6LdGhu0UAAAAAHRDh2bM97TEDB9UMBZSLjtsKe4F',
  FB_APP_ID: '357222842020135',
};
